export const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiaGF1bGl0byIsImEiOiJja28xcDVzbnQwcnR2Mm9tdnozOWNqZ25nIn0.Gzbkmpu2X272K8sQRudKJA';
